import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const OrdersActionTypes = {
  FETCH_ORDER: createSubtypes('orders|fetchOrder'),
  FETCH_ORDER_ALERT_MESSAGE: createSubtypes('orders|fetchOrderAlertMessage'),
  CREATE_DESIGN_TO_ORDER: createSubtypes('orders|createDesignToOrder'),
  CALCULATE_TAX: createSubtypes('orders|calculateTax'),
  FETCH_ALL_BUCKETS_FILES_BY_ID: createSubtypes('orders|fetchAllBucketsFilesById'),
  SET_TASK_DATE: createSubtypes('orders|setTaskDate'),
  SET_ROOF_INSTALL_COMPLETE: createSubtypes('orders|setRoofInstallComplete'),
  SCHEDULE_DATE_CLEAN_UP: createSubtypes('orders|scheduleDateCleanUp'),
};

export const OrderMetricsActionTypes = {
  FETCH_ORDER_METRIC: createSubtypes('orderMetrics|fetchOrderMetric'),
};
